import { isTopologyGraphMetadata } from 'components/Graph/GraphState';
import { loadGraph } from 'components/Graph/commands/loadGraph';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';

/**
 * Apply settings = update site using current value of layoutSettings.presetDraft
 */
export const submitTechnologies: GraphCommandFactory =
  (cmdContext, dispatch) => async () => {
    const { graphMetadata } = cmdContext.getState();
    if (!isTopologyGraphMetadata(graphMetadata)) {
      return;
    }

    await dispatch(loadGraph, {
      overlay: 'keep',
      parameters: {
        ...graphMetadata.parameters,
        technologies: cmdContext.getState().technologies.selectedTechnologies,
      },
    });
  };
